import {createSlice, PayloadAction} from '@reduxjs/toolkit'

export interface IUserData {
    name?: string,
    email?: string,
    phone?: string,
    p_s?: string,
    Sadat?: string,
    address?: string,
    birthday?: string,
    gender?: string
}

const initialState: IUserData = {}
export const UserDataSlice = createSlice({
    name: 'UserData',
    initialState,
    reducers: {
        setUserData: (state, action: PayloadAction<IUserData>) => {
            return {...state, ...action.payload};
        },
        unsetUserData: (): any => {
            return null;
        }
    },
})
// Action creators are generated for each case reducer function
export const {setUserData, unsetUserData} = UserDataSlice.actions
export default UserDataSlice.reducer